export const editMutations = <const>{
	PARTNER_JINY_PLATCE_SELECT_MAPPER: 'PARTNER_JINY_PLATCE_SELECT_MAPPER',
	PARTNER_MAT_FIRM_SELECT_MAPPER: 'PARTNER_MAT_FIRM_SELECT_MAPPER',
	PARTNER_PRACOVNIK_SELECT_MAPPER: 'PARTNER_PRACOVNIK_SELECT_MAPPER',
	PARTNER_KONTAKT_MERGE_DATA: 'zakznikKonMerge',
	SET_ARES_DATA: 'setAresData',
	PARSE_ADDRESS: 'parseAddress',
	MAP_CDB_ZAKAZNIK: 'mapCDBZakaznik',
};

export const listMutations = <const>{
	PARTNER_JINY_PLATCE_FILTER_SELECT_MAPPER: 'PARTNER_JINY_PLATCE_FILTER_SELECT_MAPPER',
};

export const mergeActions = <const>{
	GET_PARTNER: 'GET_PARTNER',
};

export const editActions = <const>{
	SET_CDB_ZAKAZNIK: 'setCDBZakaznik',
};

export enum PARTNER_TYPE {
	VSICHNI = 0,
	FYZICKA = 1,
	PRAVNICKA = 2,
	PRODEJCI = 3,
	INTERNI = 4,
	FLEET_ZAKAZNIK = 5,
}
